import { dateFilters } from '../date-filters';
import { dateUtils } from '../../../routes/utils';

const createMonthSlot = (date) => ({
  year: date.getFullYear(),
  month: date.getMonth(),
});

const createDaySlot = (date) => ({
  day: date.getDay(),
  dateNumber: date.getDate(),
  selectedTime: { from: 0 },
});

const createEmptyDate = (date, currentDay) => {
  const newDate = new Date(date);
  newDate.setDate(currentDay);
  return {
    date: dateUtils.getFormattedDate(newDate),
    times: [],
    ...createDaySlot(newDate),
  };
};

const emptyDates = (date) => {
  const dates = [];
  if (date) {
    for (let i = 1; i < date.getDate(); i += 1) {
      const emptyDate = createEmptyDate(date, i);
      dates.push(emptyDate);
    }
  }
  return dates;
};

const filterTimeSlots = (timeSlots, eligibleSlotsFilter) =>
  timeSlots.filter((time) => dateFilters.some((filter) => eligibleSlotsFilter(filter, time)));

export const formatSlotsData = (slots, startDate, eligibleSlotsFilter) => {
  if (!slots.length) {
    return null;
  }
  return slots.reduce(
    (newMonth, { date, times }) => {
      const dateObj = dateUtils.getDateFromString(date);

      const timeSlots = filterTimeSlots(times, eligibleSlotsFilter);
      const newDateSlot = { date, times: timeSlots, ...createDaySlot(dateObj) };
      const newDates = newMonth.dates.concat([newDateSlot]);
      return { ...newMonth, dates: newDates };
    },
    {
      ...createMonthSlot(dateUtils.getDateFromString(slots[0].date)),
      dates: emptyDates(dateUtils.getDateFromString(startDate)),
    },
  );
};

const withinTimeSlot = (filtersIds, timeSlot, eligibleSlotsFilter) => {
  const chosenFilters = dateFilters.filter(({ id }) => filtersIds.includes(id));
  return chosenFilters.length
    ? chosenFilters.some((dateFilter) => eligibleSlotsFilter(dateFilter, timeSlot))
    : true;
};

export const filterSlots = (slots, filtersIds, eligibleSlotsFilter) =>
  !filtersIds.length
    ? slots
    : slots.map((month) => ({
        ...month,
        dates: month.dates.map((date) => ({
          ...date,
          times: date.times.filter((time) => withinTimeSlot(filtersIds, time, eligibleSlotsFilter)),
        })),
      }));

export const findDateSlot = (dates, dateSlot) =>
  dates.find(({ date, times }) => date === dateSlot && times.length > 0);

export const findTimeSlot = (selectedDate = { times: [] }, timeSlot, appointmentTypeId) =>
  selectedDate.times.find(
    ({ from, appointmentTypeId: slotAppointmentTypeId }) =>
      from === timeSlot.from && slotAppointmentTypeId === appointmentTypeId,
  );

export const calendarHelpers = {
  findDateSlot,
  findTimeSlot,
};
